module.exports = __webpack_public_path__ + "static/media/pncrew.c4b810c8.jpg";